import { TransportRequestAction } from 'types'

export type ActionType = 'default' | 'danger'

export const getActionType = (action: TransportRequestAction) => {
  switch (action) {
    case TransportRequestAction.Reject:
      return 'danger'
    default:
      return 'default'
  }
}
